import React, { useEffect } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Section1 from "./Section1";
import PricingCard from "./PricingCard";
import CardContainer from "./CardContainer";
import InformationSection from "./InformationSection";
import AccordionSection1 from "./AccordionSection1";
import AccordionSection2 from "./AccordionSection2";
import AccordionSection3 from "./AccordionSection3";
import AccordionIntro from "./AccordionIntro";
import ConnectionApps from "./ConnectionApps";
import TwoCardsSection from "./TwoCardsSection";
import PaymentMethod from "./PaymentMethod";
// import FAQList from "../QuestionAnswerSection/Section12";
import ChooseSection from "./ChooseSection";
import { Stack } from "@mui/material";
import FAQList from "./FAQList";
import CertificateCard from "../CertificateCard/CertificateCard";
import BlogcardSection from "../BlogSection/BlogcardSection";

const PriceSection = () => {
  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />

      <main>
        <Section1 />
        {/* <PricingCard /> */}
        <CardContainer />
        <InformationSection />
        <AccordionIntro />
        <AccordionSection1 />
        <AccordionSection2 />
        <AccordionSection3 />
        <ConnectionApps />
        <TwoCardsSection />
        <PaymentMethod />
        <ChooseSection />
        {/* <Stack sx={{ marginBottom: { xl: "80px", lg: "60px", md: "40px" } }}> */}
          <FAQList />
        {/* </Stack> */}
      </main>
      <CertificateCard />

      {/* <BlogcardSection /> */}
      <Footer />
    </>
  );
};

export default PriceSection;



